<template>
  <div class="RemoteSensingMall">

    <div class="banner">
      <div class="w" style="position: relative">
        <!--        <div class="banner_join">-->
        <!--          <div class="join_info">-->
        <!--            <div class="join_infoBox">-->
        <!--              <div class="join_infoNumber">{{ shopsResources }}</div>-->
        <!--              <div class="join_infoText">数据资源</div>-->
        <!--            </div>-->
        <!--            <div class="join_infoBox">-->
        <!--              <div class="join_infoNumber">{{ shopsDemand }}</div>-->
        <!--              <div class="join_infoText">发布需求</div>-->
        <!--            </div>-->
        <!--            <div class="join_infoBox">-->
        <!--              <div class="join_infoNumber">{{ shopsShoper }}</div>-->
        <!--              <div class="join_infoText">入驻商家</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <template v-if="false">-->
        <!--            &lt;!&ndash; 预留审核中审核失败等状态的展示入口 &ndash;&gt;-->
        <!--            <div class="join_Btn">-->
        <!--              审核中-->
        <!--            </div>-->
        <!--          </template>-->
        <!--          <template v-else>-->
        <!--            <div class="join_Btn" @click="toMerchantSettled" v-if="this.$store.state.user.userInfo.userIdentity==1">-->
        <!--              立即入驻-->
        <!--            </div>-->
        <!--            <div class="join_Btn" @click="toReview_business_activity" v-else>-->
        <!--              审核动态-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </div>-->
      </div>
      <div class="middleBannerBox w">
        <div class="middleBanner middleBannerImg1">
          <div class="titleAndbtn">
            <div class="middleBanner_title">猜你喜欢</div>
            <div class="middleBanner_Btn"><i class="el-icon-arrow-right"></i></div>
          </div>

          <div class="middleBanner_Info">选择您最需要的产品</div>
        </div>

        <div class="middleBanner middleBannerImg2">
          <div class="titleAndbtn">
            <div class="middleBanner_title">1分钟了解交易平台</div>
            <div class="middleBanner_Btn"><i class="el-icon-arrow-right"></i></div>
          </div>

          <div class="middleBanner_Info">做遥感界的探路者</div>

        </div>

        <div class="middleBanner middleBannerImg3">
          <div class="titleAndbtn">
            <div class="middleBanner_title">商城公告</div>
            <div class="middleBanner_Btn"><i class="el-icon-arrow-right"></i></div>
          </div>

          <div class="middleBanner_Info">
            高分辨率对地观测系统广西数据与应用中心来访并汇报工作
          </div>

        </div>
      </div>
    </div>

    <div class="ruzhu">
      <ul>
        <li>
          <div class="left">
						<img style="width: 100%;height: 100%;" src="../../assets/imgs/RemoteSensingMall/sjzy.png" alt="">
          </div>
          <div class="right">
            <div>数据资源</div>
            <div class="count">{{ shopsResources | filter }}</div>
          </div>
        </li>

				<li>
					<div class="left">
						<img style="width: 100%;height: 100%;" src="../../assets/imgs/RemoteSensingMall/fbxq.png" alt="">
					</div>
					<div class="right">
						<div>发布需求</div>
						<div class="count">{{ shopsDemand | filter }}</div>
					</div>
				</li>

				<li style="cursor: pointer" @click="rzqy">
					<div class="left">
						<img style="width: 100%;height: 100%;" src="../../assets/imgs/RemoteSensingMall/rzdw.png" alt="">
					</div>
					<div class="right">
						<div>入驻企业</div>
						<div class="count">{{ shopsShoper | filter }}</div>
					</div>
				</li>
<!--        <li>发布需求 <span>{{ shopsDemand | filter }}</span></li>-->
<!--        <li>入驻商家 <span>{{ shopsShoper | filter }}</span></li>-->
        <li v-if="this.$store.state.user.userInfo.supplierStatus==1"><span @click="toMerchantSettled">立即入驻</span></li>
        <li v-else><span @click="toReview_business_activity">商家审核 <img src="../../assets/imgs/RemoteSensingMall/back.png" alt="" style="height: 15px;vertical-align: -0.2em"></span></li>
      </ul>
    </div>

    <div class="w">
      <div class="modTitleBox">
        <div class="modTitle">
          <div>数据服务</div>
          <div class="modTitle_info">精品钜惠，尽享不停</div>
        </div>
        <div class="modTitle_more" @click="toShop">更多</div>
      </div>
      <div class="dataShowBox">
        <div class="dataShow_data">
          <div class="dataShow_dataItem" v-for="(item, index) in fixedGoodsList" :key="index" @click="toDetail(item)"
               v-if="index<6">
            <div class="dataShow_dataItemImgBox">
              <el-image style="width: 100%; height: 210px" :src="item.goodsThumbnail" fit="cover"></el-image>

              <!--              <img v-if="item.goodsThumbnail" :src="item.goodsThumbnail" alt="">-->
              <!--              <el-image v-else style="width: 100%;height: 210px;line-height: 210px;text-align: center;position: relative">-->
              <!--                <div slot="error" class="image-slot">-->
              <!--                  <i class="el-icon-picture-outline"></i>-->
              <!--                  <div style="position: absolute;top: 50px;left: 40%;color: #909399;">暂无图片</div>-->
              <!--                </div>-->
              <!--              </el-image>-->
            </div>
            <div class="dataShow_dataItemInfoBox">
              <div class="dataShow_dataItemInfo of-2">
                {{ item.goodsName }}
              </div>
              <div class="spanItem">
                <!-- <span class="date">{{ item.createTime }}</span> -->
                <!-- 分辨率 -->
                <span class="tag1">分辨率：{{ item.productDistinguishability }}</span>
                <!-- 云量 -->
                <span class="tag2">云量：{{ item.cloudCover }}</span>
                <span class="command">{{ item.commentNum }}<span>评价</span></span>
              </div>
              <div v-if="item.goodsPriceType==3" class="dataShow_dataItemInfoMoney" style="color: #66cc79">免费</div>
              <div v-else-if="item.goodsPriceType==2" class="dataShow_dataItemInfoMoney" style="color: #E6A23C">面议</div>
              <div v-else class="dataShow_dataItemInfoMoney">
                <template v-if="item.goodsPrice > 0">
                  ￥{{ item.goodsPrice | NumFormat }}
                </template>
                <template v-else>
                  <div class="dataShow_dataItemInfoMoney" style="color: #66cc79">免费</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="dataShow_rank">
          <div class="dataShow_rankTitle">排行榜</div>
          <rankList :todayCount="todayCount" :allCount="allCount"></rankList>
        </div>
      </div>

      <!--================================-->
      <div class="modTitleBox">
        <div class="modTitle">
          <div>产品板块</div>
          <div class="modTitle_info">融合前沿数据，引领智慧科技</div>
        </div>
        <div class="modTitle_more" @click="toShop">更多</div>
      </div>

      <div class="cpbk">
        <div class="left" v-if="cpbkleft.length > 0">
          <div>
            <img :src="getcpbkleftImg.plateBackground" alt="">
            <div class="mask">
              <div>
                <span>{{ getcpbkleftImg.plateName }}</span>
                <!--                <div>-->
                <!--                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi, aspernatur beatae corporis ducimus earum facilis illo iure iusto labore molestias natus optio perferendis placeat quaerat quidem rem sunt vel voluptate.-->
                <!--                </div>-->
                <p class="ljxq" @click="clickljxq(getcpbkleftImg)">了解详情</p>
              </div>
            </div>
          </div>
          <ul>
            <li v-for="(item,index) in cpbkleft" :key="index" @click="clickcpbk('left',index)"
                :class="{clickcpbk: cpbkcurrentIndex === index}"><span>{{ item.plateName }}</span></li>
          </ul>
        </div>
        <div class="right" v-if="cpbkright.length > 0">
          <div>
            <img :src="getcpbkrightImg.backgroundImg" alt="">
            <div class="mask">
              <div>
                <span>{{ getcpbkrightImg.name }}</span>
<!--                <div>-->
<!--                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias aperiam aspernatur culpa earum enim, harum illo in minima omnis, perspiciatis, suscipit temporibus. Accusantium dolore, molestiae neque optio repellendus repudiandae tempore?-->
<!--                </div>-->
                <p class="ljxq" @click="clickljxqr(getcpbkrightImg)">了解详情</p>
              </div>
            </div>
          </div>
          <ul>
            <li v-for="(item,index) in cpbkright" :key="index" @click="clickcpbk('right',index)"
                :class="{clickcpbk: cpbkcurrentIndex2 === index}">{{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--    <div class="productbanner">-->
    <!--      <div class="w" style="position: relative; padding-top: 36px">-->
    <!--        <div class="modTitleBox" style="margin-top: 0">-->
    <!--          <div class="modTitle" style="color: #fff">产品板块</div>-->
    <!--          <div class="modTitle_info" style="color: #b9bac8">-->
    <!--            融合前沿数据，引领智慧科技-->
    <!--          </div>-->
    <!--          <div class="modTitle_more" style="color: #b9bac8" @click="toShop">更多》</div>-->
    <!--        </div>-->

    <!--        <div style="width: 100%; margin: 10px auto; position: relative">-->
    <!--          <ul class="CourseCenter-list">-->
    <!--            <li v-for="(item, i) in ServiceCourseCenter" :key="i" @mouseover="ServiceCourseCenterCheckedIndex = i"-->
    <!--                @mouseleave="ServiceCourseCenterCheckedIndex = 'x'">-->
    <!--              <div class="CourseCenter-card" @click="productServicePage(item.id)">-->
    <!--                <div class="CourseCenter-card-cover"-->
    <!--                     :style="{ backgroundImage: 'url(' + item.plateBackground + ')' }"></div>-->
    <!--                <div class="CourseCenter-card-cover-mask"></div>-->
    <!--                <div class="CourseCenter-card-text">-->
    <!--                  <img :src="item.plateThumbnail" alt="" style=""/>-->
    <!--                  <div class="CourseCenter-card-title">{{ item.plateName }}</div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </li>-->
    <!--          </ul>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </div>-->

    <scheme></scheme>
    <show-shop-list :show="show" @close="shopListClose"></show-shop-list>
  </div>
</template>

<script>
import rankList from "@/components/RemoteSensingMall/rankList.vue";
import scheme from "@/components/scheme.vue"

import ShowShopList from "@/views/RemoteSensingMall/ShowShopList.vue";
import {ClassificationOfGoods, GoodsModuleClass} from "@/const/RemoteSensingMall";

export default {
  filters: {
    filter(value) {
      if (value < 10) {
        return 0 + '' + value
      } else {
        return value
      }
    }
  },
  components: {
    rankList,
    scheme,
    ShowShopList
  },
  data() {
    return {
      show: false,

      getGoodsNum: 10, // 固定商品数量
      fixedGoodsList: [], //固定产品列表
      todayCount: 0, //今日销售数量
      allCount: 0, //总销售数量
      shopsResources: 0,
      shopsDemand: 0,
      shopsShoper: 0,
      ServiceCourseCenter: [],
      ServiceCourseCenterCheckedIndex: "x",
      dataImg: require("@/assets/imgs/RemoteSensingMall/dataImg.png"),

      cpbkcurrentIndex: 0,
      cpbkcurrentIndex2: 0,

      cpbkleft: [],
      cpbkright: []
    };
  },
  computed: {
    getcpbkleftImg() {
      return this.cpbkleft[this.cpbkcurrentIndex]
    },
    getcpbkrightImg() {
      return this.cpbkright[this.cpbkcurrentIndex2]
    }
  },
  created() {
    //获取产品板块
    this.getleftGoodClass()
    this.getrightGoodClass()
  },
  mounted() {
    // 获取商家统计信息
    this.initShopsStatic();
    // 获取固定数量产品
    this.initGoodsFixedNum();
    // 获取商品销售量
    this.initGoodsCount();
    // 获取商品板块分类
    this.initGoodsClass();

  },
  methods: {
    rzqy() {
      this.show = true
    },
    shopListClose() {
      this.show = false
    },
    async getleftGoodClass() {
      let res = await this.$http
          .get(this.$const.RemoteSensingMall.GoodsModuleClass, "")
      if (res.code === 200) {
        this.cpbkleft = res.data
      }
    },
    async getrightGoodClass() {
      let res = await this.$http
          .get(this.$const.RemoteSensingMall.ClassificationOfGoods, "")
      if (res.code === 200) {
        this.cpbkright = res.data
      }
    },
    clickljxqr(obj) {
      this.$router.push({
        name: 'search',
        query: {
          softType: obj.id
        }
      })
    },
    clickljxq(obj) {
      this.$router.push({
        name: 'search',
        query: {
          goodsType: obj.id
        }
      })
    },

    clickcpbk(type, index) {
      if (type === 'left') {
        this.cpbkcurrentIndex = index
      } else {
        this.cpbkcurrentIndex2 = index
      }
    },

    initShopsStatic() {
      this.$http
          .get(this.$const.RemoteSensingMall.shopsStatic, "")
          .then((res) => {
            // console.log("获取商家统计信息:", res);
            if (res.code == 200) {
              // this.shopsResources = res.data.totalGoodsNum;
              // this.shopsDemand = res.data.totalDemandGoodsNum;
              // this.shopsShoper = res.data.totalSupplierNum;

              //写死
              this.shopsResources = 130;
              this.shopsDemand = 23;
              this.shopsShoper = 31;
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    initGoodsFixedNum() {
      this.$http
          .get(this.$const.RemoteSensingMall.GoodsFixedNum + this.getGoodsNum, "")
          .then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.fixedGoodsList = res.data;
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    initGoodsCount() {
      this.$http
          .get(this.$const.RemoteSensingMall.GoodsCount, "")
          .then((res) => {
            // console.log("获取商品销售量:", res);
            if (res.code == 200) {
              this.todayCount = res.data.todayNum;
              this.allCount = res.data.totalNum;
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    initGoodsClass() {
      this.$http
          .get(this.$const.RemoteSensingMall.GoodsModuleClass, "")
          .then((res) => {
            // console.log("获取商品板块分类:", res);
            if (res.code == 200) {
              this.ServiceCourseCenter = res.data;
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    toDetail(item) {
      // console.log(item.goodsId)
      this.$router.push({
        path: "/shopDetail",
        query: {
          goodsId: item.goodsId
        }
      });
    },
    toShop() {
      this.$router.push({path: "/search"});
    },
    toMerchantSettled() {
      if (this.$store.state.user.userInfo.registerIdentity == 1) {
        this.$message.warning(this.$PubText.toMerchantWarn);
      } else {
        this.$router.push({path: "/MerchantSettled"});
      }

    },
    toReview_business_activity() {
      this.$router.push({path: "/AdvisoryCenter"});
    },
    // 服务能力链接跳转
    productServicePage(id) {
      // console.log("板块id：", id);
      this.$router.push({path: "/search", query: {id: id}});
    },
  },
};
</script>

<style lang="scss" scoped>
.ruzhu {
  width: 100%;
  height: 140px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 51%, rgba(255, 255, 255, 0) 100%);
  box-shadow: 0px 5px 20px 0px rgba(37, 105, 242, 0.1);

  ul {
    width: 1400px;
    height: inherit;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      text-align: center;
      //height: 60px;
      //line-height: 60px;
      width: 25%;
      display: flex;
      justify-content: center;

      font-size: 16px;
      font-family: MicrosoftYaHeiUI;
      color: #000000;
      font-weight: 600;
      display: flex;
      align-items: center;

      .left {
        height: 100px;
      }
      .right {
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .count {
          color: #2569F2;
          font-size: 36px;
        }
      }

      span {
        font-family: Quartz-Regular;
        font-size: 24px;
        margin-left: 15px;
        color: #3775f3;
      }

      &:last-child {
        height: auto;
        line-height: normal;

        span {
          padding: 6px 15px;
          font-size: 14px;
          background: #2569F2;
          border-radius: 4px;
          border: 1px solid #2569F2;
          color: white;
          margin: 0;
          cursor: pointer;
        }
      }
    }
  }
}

.cpbk {
  display: flex;
  padding-bottom: 65px;
  justify-content: space-between;

  .ljxq {
    margin: 10px 0;
    cursor: pointer;
  }

  @mixin cpbkstyle {
    width: 49%;
    height: 600px;
    display: flex;
    div:first-child {
      position: relative;
      width: 500px;

      img {
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }

      .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        transition: .4s;
        overflow: hidden;

        & > div {
          font-size: 24px;
          font-family: MicrosoftYaHeiUI;
          color: #FFFFFF;
          position: absolute;
          bottom: 30px;
          padding-left: 30px;
          transition: inherit;

          div {
            width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; //显示行数

            opacity: 0;
            transition: inherit;
            height: 0;
            font-size: .6em;
          }

          p {
            opacity: 0;
            transition: inherit;
            height: 0;
            font-size: .5em;
          }

          span::after {
            content: '——';
            display: block;
          }
        }
      }

      .mask:hover {
        background: rgba(0, 0, 0, 0.46);

        & > div {
          bottom: 40%;

          div {
            opacity: 1;
            height: auto;
          }

          p {
            opacity: 1;
            height: auto;
          }
        }

        span {
          bottom: 50%;
          transform: translateY(50%);
        }
      }
    }
    ul {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      background: white;
      width: 30%;

      li {
        list-style: none;
        width: 100%;
        flex-grow: 1;

        font-size: 20px;
        font-family: MicrosoftYaHeiUISemilight;
        color: #9ebcf9;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;
      }

      li:hover, .clickcpbk {
        background: linear-gradient(90deg, rgba(37, 105, 242, 0) 10%, rgba(37, 105, 242, .7) 100%);
        color: #2569F2;
      }
    }
  }

  .left {
    @include cpbkstyle
  }

  .right {
    @include cpbkstyle
  }
}

.CourseCenter-list {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.CourseCenter-list > li {
  width: 25%;
  flex-grow: 1;
  padding-left: 8px;
  padding-right: 8px;
  -webkit-transition: 0.65s;
  transition: 0.65s;
  margin-bottom: 15px;
}

.CourseCenter-list .CourseCenter-card {
  display: block;
  position: relative;
  height: 370px;
  background-size: cover;
  background-position: 0;
  overflow: hidden;
  color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  box-shadow: 0px 4px 20px 0px rgba(60, 110, 240, 0.15);
  border-radius: 8px;
  cursor: pointer;
}

.CourseCenter-card-cover {
  background-size: cover;
  background-position: 0;
  filter: blur(6px);
}

.CourseCenter-card-cover,
.CourseCenter-card-cover-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: 0.65s;
  transition: 0.65s;
  background: rgba(0, 0, 0, 0.46);
  background-size: cover;
}

.CourseCenter-card-text {
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  height: auto;
  text-align: center;
  -webkit-transition: 0.65s;
  transition: 0.65s;
  margin-top: 130px;
  -webkit-transform: translateY(0);
  transform: translateY(0);
}

.CourseCenter-card-title {
  position: relative;
  font-size: 0.9vw;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  font-weight: 700;
  color: #ffffffbd;
  line-height: 24px;
  margin-top: 10px;
}

.CourseCenter-card-more {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  opacity: 0;
  cursor: pointer;
}

.CourseCenter-list li:hover .CourseCenter-card-cover-mask {
  background: rgba(0, 0, 0, 0);
}

.CourseCenter-list li:hover .CourseCenter-card-text {
  top: 60%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  margin-top: 0;
}

.CourseCenter-list li:hover .CourseCenter-card-title {
  color: #fff;
}

.CourseCenter-list li:hover .CourseCenter-card-cover {
  -webkit-filter: blur(0px);
  filter: blur(0px);
}

.CooperativeUniversities {
  width: 100%;
  min-height: 60vh;
  background: #dfe9ff;
}

.productbanner {
  position: relative;
  width: 100%;
  margin: 0;
  padding-bottom: 30px;
  background-image: url("../../assets/imgs/RemoteSensingMall/plan-serviceBg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.dataShow_rankBox {
  border-bottom: 1px dashed #ccc;
  font-size: 14px;
  margin-bottom: 10px;
}

.dataShow_rankItemHot {
  width: 15%;
}

.dataShow_rankItemText {
  width: 80%;
}

.dataShow_rankItemNub {
  width: 5%;
}

.dataShow_rankItem:nth-child(-n + 3) {
  color: #2469f1;
}

.dataShow_rankItem:hover {
  color: #2469f1;
}

.dataShow_rankItem {
  width: 100%;
  height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
}

.dataShow_rankTitle {
  font-size: 18px;
  margin-bottom: 10px;
}

.dataShow_dataItemInfo {
  font-size: 14px;
  width: 100%;
  height: 28px;
  line-height: 14px;
  margin-bottom: 10px;
}

.dataShow_dataItemInfoMoney {
  font-weight: bold;
  color: #e24087;
}

.dataShow_dataItemInfoBox {
  padding: 10px;
}

.dataShow_dataItemImgBox {
  overflow: hidden;

  img {
    width: 100%;
    height: 210px;
    transition: all 0.75s;
  }

  img:hover {
    transform: scale(1.1);
  }
}

.dataShow_dataItem {
  width: 32%;
  height: 327px;
  //margin-bottom: 10px;
  background: #fff;
  //border: 1px solid #ccc;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, .2);
  transition: .3s;
}

/* 如果最后一行是2个元素 */
.dataShow_dataItem:last-child:nth-child(3n - 1) {
  margin-right: calc(30% + 10% / 2);
}

.dataShow_dataItem:hover {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, .6);
  .dataShow_dataItemInfo {
    color: #2569f2;
  }
}



.dataShow_rank {
  width: 25%;
  padding: 20px;
  background: #FFFFFF;
  height: 671px;
}

.dataShow_data {
  width: 72%;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 20px;
}

.dataShowBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.RemoteSensingMall {
  background: #f5f5f5;
}

.modTitle_more:hover {
  color: #2469f1;
}

.modTitle_more {
  position: absolute;
  right: 0;
  top: 45%;
  font-size: 18px;
  font-family: MicrosoftYaHeiUI;
  color: #2569F2;
  letter-spacing: 1px;
  cursor: pointer;
}

.modTitle_info {
  //text-align: center;
  font-size: 20px;
  font-family: MicrosoftYaHeiUI;
  color: #666666;
  margin-left: 38px;
}

.modTitle {
  color: #000;
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 6px;
  display: flex;
  align-items: baseline;

  div:first-child {
    font-size: 32px;
    font-family: MicrosoftYaHeiUISemibold;
    color: #2569F2;
    letter-spacing: 2px;
  }
}

.modTitleBox {
  position: relative;
  margin-top: 65px;
  margin-bottom: 20px;
}

.middleBanner_Btn {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #FFFFFF;
  border-radius: 50%;
  margin-left: 8px;
  cursor: pointer;
  text-align: center;
}

.middleBanner_Info {
  font-size: 14px;
  color: #fff;
  margin: 10px 0;
}

.middleBanner_title {
  font-size: 22px;
  color: #fff;
  //margin-bottom: 6px;
}

.middleBannerImg3 {
  //background-image: url("../../assets/imgs/RemoteSensingMall/middleBanner3.png");
  //background-repeat: no-repeat;
  //background-position-y: -1px;
  //background-size: cover;
  width: 466px;
  height: 100px;
  background: linear-gradient(180deg, #A87F0C 0%, rgba(168, 127, 12, 0) 100%);
  backdrop-filter: blur(0px);
  padding: 30px 22px;
  transition: .4s;
}

.middleBannerImg3:hover {
  backdrop-filter: blur(15px);
}

.middleBannerImg2:hover {
  backdrop-filter: blur(15px);
}

.middleBannerImg1:hover {
  backdrop-filter: blur(15px);
}

.middleBannerImg2 {
  //background-image: url("../../assets/imgs/RemoteSensingMall/middleBanner2.png");
  //background-repeat: no-repeat;
  //background-position-y: -1px;
  //background-size: cover;
  width: 467px;
  height: 100px;
  backdrop-filter: blur(0px);
  padding: 30px 22px;
  transition: .4s;
  background: linear-gradient(180deg, #0CA82E 0%, rgba(12, 168, 46, 0) 100%);
}

.middleBannerImg1 {
  width: 467px;
  height: 100px;
  background: linear-gradient(180deg, #2569F2 0%, rgba(37, 105, 242, 0) 100%);
  backdrop-filter: blur(0px);
  padding: 30px 22px;
  transition: .4s;
  //background-image: url("../../assets/imgs/RemoteSensingMall/middleBanner1.png");
  //background-repeat: no-repeat;
  //background-position-y: -1px;
  //background-size: cover;
}

.middleBanner {
  //width: 32%;
  height: 100px;
  //padding: 40px 20px;
}

.titleAndbtn {
  display: flex;
  align-items: center;
}

.middleBannerBox {
  display: flex;
  //margin-top: 20px;
  //justify-content: space-between;
  position: relative;
  top: 330px;
}

.join_Btn {
  color: #fff;
  background: #2469f1;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}

.join_infoNumber {
  font-size: 20px;
  color: #2469f1;
  margin-bottom: 4px;
}

.join_infoText {
  font-size: 14px;
}

.join_infoBox {
  flex: 1;
}

.banner {
  position: relative;
  width: 100%;
  margin: 0;
  height: 430px;
  background-image: url("../../assets/imgs/RemoteSensingMall/indexBanner.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.banner_join {
  position: absolute;
  right: 0;
  top: 20px;
  background: #fff;
  width: 300px;
  padding: 24px 20px;
}

.join_info {
  display: flex;
  text-align: center;
}

.spanItem {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .date,
  .tag1,
  .tag2 {
    display: inline-block;
    font-size: 12px;
    color: #2569F2;
  }

  .date {
    width: 70px;
  }

  .tag1 {
    margin: 0 3px;
  }

  .tag1,
  .tag2 {
    padding: 3px;
    text-align: center;
    border: 1px solid #eaeaea;
    border-radius: 5px;
    background: #dfe9fd;
  }

  span.command {
    flex: auto;
    color: #3868e9;
    text-align: end;
    font-size: 13px;

    span {
      color: #666666;
    }
  }
}

.spanItem {
  padding: 5px;
}
</style>
